jQuery(document).ready(function($) {
	if (!window.WebAssessmentCharts) {
		window.WebAssessmentCharts = {}; // Create namespace if it doesn't exist
	}

	// Strips the `SA-NCA-ECC-<major>-<minor>-` framework/version prefix
	// so that numeric control IDs like `SA-NCA-ECC-1-0-2.12.1` become `2.12.1`
	// and can be treated the same way numeric CIS safeguard IDs are.
	const SA_NCA_ECC_PREFIX_REGEX = /^SA-NCA-ECC-\d+-\d+-/i;
	function stripSaNcaEccPrefix(controlId) {
		if (typeof controlId !== 'string') {
			return controlId;
		}
		return controlId.replace(SA_NCA_ECC_PREFIX_REGEX, '');
	}

	// Extracts the subdomain key `<major>.<minor>` (e.g. "2.12" from "2.12.1",
	// "1.10" from "1.10.3.4"). This matches the dashboard table's
	// `data-subdomain` rows and the authoring-side topic keys.
	function getSaNcaEccCategory(controlId) {
		const numericId = stripSaNcaEccPrefix(controlId);
		if (!numericId) {
			return null;
		}
		const parts = numericId.split('.');
		if (parts.length < 2) {
			return null;
		}
		return parts[0] + '.' + parts[1];
	}

	let projectID;
	if ($('body').hasClass('single-projects')) {
		const pathParts = window.location.pathname.split('/projects/');
		if (pathParts.length > 1) {
			projectID = pathParts[1].split('/')[0];
			console.log('Extracted projectID:', projectID);
		}
	}

	// Now using utility function from fetchProjectChartData.js
	WebAssessmentCharts.fetchProjectChartData = fetchProjectChartData;
	var homeFrameworkProcessUniqueItems = processUniqueItemsCIS;

	// Fetch project data and standard data, then process them together
	WebAssessmentCharts.fetchDataAndCalculateScores = async function (projectID) {
		const pathParts = window.location.pathname.split('/projects/');
		if (pathParts.length > 1) {
			projectID = pathParts[1].split('/')[0];
		}

		try {
			const projectDataPromise = WebAssessmentCharts.fetchProjectChartData(projectID);
			const [projectData] = await Promise.all([projectDataPromise]);

			if (!projectData || !Array.isArray(projectData)) {
				console.error('Project data is missing or not structured as expected:', projectData);
				return;
			}

			const projectItems = projectData;
			const processedItems = homeFrameworkProcessUniqueItems(projectItems);
			console.log('Processed Items:', processedItems);

			// Fetch SA-NCA-ECC standards data
			try {
				const response = await jQuery.ajax({
					url: controlsData.ajax_url,
					type: 'POST',
					dataType: 'json',
					data: {
						action: 'api_action',
						year: '2024',
						apis: ['CS'],
						CSLstandardID: 'SA-NCA-ECC-1-0'
					}
				});

				console.log('SA-NCA-ECC Standards response structure:', JSON.stringify(response, null, 2));
				WebAssessmentCharts.saNcaEccStandardData = response;

				if (!response.CS || !response.CS.Items) {
					console.error('Invalid SA-NCA-ECC standards response structure:', response);
					return;
				}

				WebAssessmentCharts.SANCAECC(processedItems, response);

			} catch (error) {
				console.error('Error fetching SA-NCA-ECC standards:', error);
				// Fall back to rendering with project data only
				WebAssessmentCharts.SANCAECC(processedItems);
			}

		} catch (error) {
			console.error('Error processing data:', error);
		} finally {
			$('.modal-body .loader').hide();
		}
	};

	if (typeof WebAssessmentCharts.registerHomeDashboardFetcher === 'function') {
		WebAssessmentCharts.registerHomeDashboardFetcher('sa-nca-ecc-1-0', WebAssessmentCharts.fetchDataAndCalculateScores);
	}

	// Now using utility function from calculateMaturityScore.js
	WebAssessmentCharts.calculateMaturityScore = calculateMaturityScore;

	// Now using utility function from getMostRecentSafeguards.js
	WebAssessmentCharts.getMostRecentSafeguards = getMostRecentSafeguards;

	// Now using utility function from processUniqueItemsCIS.js
	WebAssessmentCharts.processUniqueItems = processUniqueItemsCIS;

	WebAssessmentCharts.calculateSaNcaEccCategoryAverages = function(items, standardData) {
		const categoryScores = {};
		const categoryPotentialCounts = {};

		// Gather potential counts from the standard data, if available
		if (standardData && standardData.CS && standardData.CS.Items) {
			standardData.CS.Items.forEach(control => {
				if (control.controlid && control.controlid.S) {
					const category = getSaNcaEccCategory(control.controlid.S);
					if (category === null || category === undefined) {
						return;
					}
					if (!categoryPotentialCounts[category]) {
						categoryPotentialCounts[category] = 0;
					}
					categoryPotentialCounts[category]++;
				}
			});
		}
		console.log('SA-NCA-ECC Category potential counts: ', categoryPotentialCounts);

		Object.keys(categoryPotentialCounts).forEach(category => {
			categoryScores[category] = {
				total: 0,
				count: 0,
				notApplicableCount: 0,
				totalItems: 0,
				potentialCount: categoryPotentialCounts[category]
			};
		});

		items.forEach(item => {
			if (!item.safeguardid || !item.safeguardid.S) {
				return;
			}
			const category = getSaNcaEccCategory(item.safeguardid.S);
			if (category === null || category === undefined) {
				return;
			}
			const maturityScore = item.maturityscore; // Can be null
			const policyStatus = item.policystatus ? item.policystatus.N : null;

			if (!categoryScores[category]) {
				categoryScores[category] = {
					total: 0,
					count: 0,
					notApplicableCount: 0,
					totalItems: 0,
					potentialCount: categoryPotentialCounts[category] || 0
				};
			}

			categoryScores[category].totalItems++;

			// Not Applicable (policy status 1)
			if (policyStatus === "1") {
				categoryScores[category].notApplicableCount++;
			} else if (maturityScore !== null) {
				categoryScores[category].total += maturityScore;
				categoryScores[category].count++;
			}
		});

		const averages = {};
		Object.keys(categoryScores).forEach(category => {
			const { total, count, notApplicableCount, totalItems, potentialCount } = categoryScores[category];

			// All items marked Not Applicable -> treat the category as null
			if (notApplicableCount === totalItems && totalItems > 0) {
				averages[category] = null;
			} else {
				const applicableCount = potentialCount ? (potentialCount - notApplicableCount) : count;
				averages[category] = applicableCount > 0 ? total / applicableCount : 0;
				console.log(`SA-NCA-ECC Category ${category}: total=${total}, potentialCount=${potentialCount}, notApplicableCount=${notApplicableCount}, applicableCount=${applicableCount}, average=${averages[category]}`);
			}
		});

		console.log('SA-NCA-ECC Category averages: ', averages);
		return averages;
	};

	WebAssessmentCharts.SANCAECC = function(items, standardData) {
		console.log('Starting SANCAECC function...');
		const tableBody = document.querySelector('#sa-nca-ecc tbody');
		if (!tableBody) {
			console.error('SA-NCA-ECC Table body not found.');
			return;
		}

		// Store original row indices before any modifications
		const originalIndices = new Map();
		Array.from(tableBody.rows).forEach((row, index) => {
			originalIndices.set(row, index);
		});

		// Build a map of all possible safeguards from the standard
		const allSafeguards = new Map();
		if (standardData && standardData.CS && standardData.CS.Items) {
			standardData.CS.Items.forEach(control => {
				if (control.controlid && control.controlid.S) {
					allSafeguards.set(control.controlid.S, {
						safeguardid: { S: control.controlid.S },
						policystatus: { N: "0" }, // Default to "Not Answered"
						maturityscore: 0
					});
				}
			});
		}

		// Merge in any existing answers
		const processedItems = homeFrameworkProcessUniqueItems(items);
		processedItems.forEach(item => {
			if (item && item.safeguardid && item.safeguardid.S) {
				allSafeguards.set(item.safeguardid.S, item);
			}
		});

		const mergedItems = Array.from(allSafeguards.values());
		console.log('SA-NCA-ECC merged items (including unanswered):', mergedItems);

		const averageScores = WebAssessmentCharts.calculateSaNcaEccCategoryAverages(mergedItems, standardData);

		const rowsToRemove = [];

		// Make all rows visible first
		Array.from(tableBody.rows).forEach(row => {
			row.style.display = '';
		});

		// Update the table: look up each row by its `data-subdomain` attribute
		// (e.g. "1.1", "1.10", "2.15"). This avoids index math that would break
		// with mixed-width subdomain keys.
		Object.keys(averageScores).forEach(category => {
			const row = tableBody.querySelector(`tr[data-subdomain="${category}"]`);
			if (row) {
				const averageScore = averageScores[category];
				const scoreCell = row.cells[1];

				if (averageScore === null) {
					rowsToRemove.push(row);
				} else {
					const scaledScore = averageScore * 5; // Scale to out of 5
					scoreCell.textContent = scaledScore.toFixed(2);
					console.log(`Updated SA-NCA-ECC subdomain ${category} with averageScore:`, scaledScore.toFixed(2));
				}
			} else {
				console.warn(`SA-NCA-ECC row not found for subdomain ${category}`);
			}
		});

		rowsToRemove.forEach(row => {
			row.remove();
		});

		// Overall maturity score
		let totalScore = 0;
		let scoreCount = 0;
		Array.from(tableBody.rows).forEach((row) => {
			const scoreText = row.cells[1].textContent;
			const score = parseFloat(scoreText);
			if (!isNaN(score)) {
				totalScore += score;
				scoreCount++;
			}
		});

		const maturityRatingRow = $('#sa-nca-ecc .light-background td');
		if (maturityRatingRow.length > 0 && scoreCount > 0) {
			const overallMaturity = totalScore / scoreCount;
			WebAssessmentCharts.overallSANCAECCmaturity = overallMaturity;

			maturityRatingRow.text(overallMaturity.toFixed(2));
			$('.audit-overall-value').text(overallMaturity.toFixed(2));
			$('.sa-nca-ecc-overall-value').text(overallMaturity.toFixed(2));
			console.log(`Updated SA-NCA-ECC overall maturity rating to ${overallMaturity.toFixed(2)}`);

			$('.spinner-border').hide();
			$('.mark-complete-modal-buttons').show();
		} else {
			console.error('Error: No scores found or maturity rating row not found in the SA-NCA-ECC table.');
		}

		$('.sa-nca-ecc-container').show();
		WebAssessmentCharts.createChartFromTable('sa-nca-ecc', 'sa-nca-ecc-chart', charts, true);

		// Restore any removed rows (kept hidden) so original indices stay stable for later runs
		rowsToRemove.forEach(row => {
			const originalIndex = originalIndices.get(row);
			if (originalIndex !== undefined) {
				tableBody.insertBefore(row, tableBody.rows[originalIndex] || null);
				row.style.display = 'none';
			}
		});
	};

	// Object to keep track of charts
	var charts = {};

	$('a.view-table').on('click', function (e) {
		e.preventDefault();
		var $button = $(this);
		var card = $button.closest('.card');
		var dataTable = card.find('.data');
		var chart = card.find('.chart');

		var isModal = $('body').hasClass('single-projects');
		var $scrollContainer = isModal ? $('.modal.show .modal-body') : $('html, body');

		dataTable.toggle();

		setTimeout(function() {
			var $targetElement;
			var headerOffset = 20;

			if (dataTable.is(':visible')) {
				$button.text('Hide Table');
				$targetElement = dataTable;
			} else {
				$button.text('View Table');
				$targetElement = card;
			}

			var currentScrollTop = $scrollContainer.scrollTop();
			var targetTop = $targetElement[0].getBoundingClientRect().top;
			var containerTop = isModal ? $scrollContainer[0].getBoundingClientRect().top : 0;

			var scrollOffset = targetTop - containerTop - headerOffset;
			var newScrollTop = currentScrollTop + scrollOffset;

			$scrollContainer.scrollTop(newScrollTop);

		}, 10);

		// Hack for the modal height to make it work across browsers
		jQuery('.dashboard-selection').select2('open');
		jQuery('.dashboard-selection').select2('close');
	});

	viewResultsProject = window.location.href;
	let currentProjectID = '';

	if (viewResultsProject.includes('#')) {
		currentProjectID = viewResultsProject.split('#')[1];
	}

	if (!currentProjectID) {
		const projectPath = viewResultsProject.split('/projects/');
		if (projectPath.length > 1) {
			currentProjectID = projectPath[1];
		}
	}

	$('.view-results').on('click', function() {
		$('.modal-body .loader').show();
		let projectPath = viewResultsProject.split('/projects/');
		if (projectPath.length > 1) {
			currentProjectID = projectPath[1].split(/[?#]/)[0];
			WebAssessmentCharts.fetchDataAndCalculateScores(currentProjectID);
		}
	});

	$(document).on('shown.bs.modal', '#projectCompleteModal', function (event) {
		if (currentProjectID) {
			console.log('Project Complete Modal detected with Project ID:', currentProjectID);
			WebAssessmentCharts.fetchDataAndCalculateScores(currentProjectID);
		} else {
			console.error('Project ID not found for #projectCompleteModal');
		}
	});
});
